// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"56528d2b","58":"e7113b07","71":"234d635c","120":"fa13df93","158":"86218243","251":"0f8ddbe7","302":"c39be4c4","329":"8e06b554","345":"752cf784","374":"4ba0bf82","453":"07a6ab98","497":"4a3d6abf","628":"773033a5","754":"6aafff04","854":"7cade817","960":"21e3021f"}[chunkId] + ".chunk.js";
};